import { useEffect, useRef } from "react";
import Hls from "hls.js";

function WatchVideo() {
  const ref = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    fetch(
      "https://192.168.5.240:4002/api/video/10152/Court_Hall_3_10152_1776241740831.mp4",
    )
      .then((r) => r.json())
      .then((data) => {
        const video = ref.current;

        if (video) {
          const hls = new Hls();
          hls.loadSource(data.url);
          hls.attachMedia(video);
        }
      });
  }, []);

  return <video ref={ref} controls width="800" />;
}

export default WatchVideo;
